import 'date-fns';
import {Button, FormControl, InputGroup} from "react-bootstrap";
import 'date-fns';
import React, {useState} from 'react';
import {Grid} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import {DatePicker} from '@material-ui/pickers';
import moment from "moment";
import {MuiPickersUtilsProvider} from "../styles/config";
import Translate from "../utils/utils";
import {useSelector} from "react-redux";
import {getLocaleFromLanguageId} from "../../_metronic/i18n/I18nProvider";
import {injectIntl} from "react-intl";
import esLocale from "date-fns/locale/es";
import itLocale from "date-fns/locale/it";
import nlLocale from "date-fns/locale/nl";
import deLocale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en-US";


const ReportSearch = (props) => {

    const {
        handleNameChange, handleDateChange, onSubmit, onClear, disabled = false, onKeyPress = () => {
        }, intl, value, dateTerm, searchName, textSearch = true
    } = props;


    const [name, setName] = useState(value || '');
    const [date, setDate] = useState(dateTerm || null);
    const initDirt = () => {
        if (name) return true;
        return !!date;
    };
    const [isDirty, setIsDirty] = useState(initDirt());
    const dateFormat = 'DD-MM-YYYY';
    let locale = 'en';
    const user = useSelector(store => store.auth.user);
    if (user) {
        locale = getLocaleFromLanguageId(user.language_id);
    }

    const onNameChange = (e) => {
        const {target: {value}} = e;
        setName(value);
        handleNameChange(value);
        setIsDirty(true);
    };

    const onDateChange = (value) => {
        const date = moment(Date.parse(value)).format(dateFormat);
        setDate(date);
        handleDateChange(date);
        setIsDirty(true);
    };

    const parseDate = (date) => {
        return moment(date, dateFormat).toDate();
    };

    const search = (e) => {
        if (name?.length > 0 || date?.length > 0) {
            onSubmit(e);
            setIsDirty(true);
        }
    };

    const clear = (e) => {
        setName('');
        setDate('');
        if (isDirty) {
            onClear();
        }
        setIsDirty(false);
    };

    const handleKeyPress = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            search(e);
        }
        onKeyPress();
    };

    const localeMap = {
        en: enLocale,
        de: deLocale,
        nl: nlLocale,
        it: itLocale,
        es: esLocale,
    };

    return (
        <>
            {/*<InputGroup className="mb-3">*/}
            {/*    <Autocomplete*/}
            {/*        multiple*/}
            {/*        className="col-lg-6 bg-light border-0"*/}
            {/*        id="tags-outlined"*/}
            {/*        options={top100Films}*/}
            {/*        getOptionLabel={(option) => option.title}*/}
            {/*        filterSelectedOptions*/}
            {/*        style={{width: 300}}*/}
            {/*        variant="outlined"*/}
            {/*        renderInput={(params) => (*/}
            {/*            <TextField*/}
            {/*                {...params}*/}
            {/*                label="Growers"*/}
            {/*                variant="outlined"*/}
            {/*                fullWidth*/}
            {/*                className="col-lg-3"*/}
            {/*            />*/}
            {/*        )}*/}
            {/*    />*/}

            {/*    <Autocomplete*/}
            {/*        onInputChange={(event, value) => {*/}
            {/*            searchBuyers(value);*/}
            {/*        }}*/}
            {/*        multiple*/}
            {/*        className="col-lg-6 bg-light border-0"*/}
            {/*        id="tags-outlined"*/}
            {/*        options={buyers}*/}
            {/*        getOptionLabel={(option) => option.title}*/}
            {/*        filterSelectedOptions*/}
            {/*        style={{width: 300}}*/}
            {/*        variant="outlined"*/}
            {/*        onChange={(event, buyers) => setSelectedBuyers(buyers)}*/}
            {/*        getOptionSelected={(option, value) => option.id === value.id}*/}
            {/*        renderInput={(params) => (*/}
            {/*            <TextField*/}
            {/*                {...params}*/}
            {/*                label="Buyers"*/}
            {/*                variant="outlined"*/}
            {/*                fullWidth*/}
            {/*                className="col-lg-3"*/}
            {/*                InputProps={{*/}
            {/*                    ...params.InputProps,*/}
            {/*                    endAdornment: (*/}
            {/*                        <React.Fragment>*/}
            {/*                            {isLoadingBuyers ? <CircularProgress color="inherit" size={20}/> : null}*/}
            {/*                            {params.InputProps.endAdornment}*/}
            {/*                        </React.Fragment>*/}
            {/*                    ),*/}
            {/*                }}*/}
            {/*            />*/}
            {/*        )}*/}
            {/*    />*/}
            {/*</InputGroup>*/}
            <InputGroup className="mb-3">

                {textSearch ?
                    <FormControl
                        placeholder={intl.formatMessage({
                            id: searchName || "TABLE.NAME"
                        })}
                        className="col-lg-3"
                        value={name}
                        onChange={onNameChange}
                        onKeyPress={handleKeyPress}
                    /> : <></>
                }


                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                    <Grid container className="col-lg-3 form-control" justifyContent="space-around">
                        <DatePicker
                            margin="none"
                            variant="none"
                            placeholder={intl.formatMessage({
                                id: "TABLE.DATE"
                            })}
                            value={date ? parseDate(date) : null}
                            onChange={onDateChange}
                            onKeyPress={handleKeyPress}
                            format="dd-MM-yyyy"
                            InputProps={{
                                disableUnderline: true,
                            }}
                            okLabel={<Translate id={"DATEPICKER.OK"}/>}
                            clearLabel={<Translate id={"DATEPICKER.CLEAR"}/>}
                            cancelLabel={<Translate id={"DATEPICKER.CANCEL"}/>}
                            locale={locale}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>

                <InputGroup.Append>
                    <Button variant="outline-secondary" onClick={search} disabled={disabled}>
                        <Translate id="SEARCH.SEARCH"/>
                        <i className="fa fa-search ml-sm-2" style={{"fontSize": ".7rem"}}/>
                    </Button>
                </InputGroup.Append>

                <Button variant="outline-secondary" className="ml-sm-3" onClick={clear} disabled={disabled}>
                    <Translate id="SEARCH.CLEAR"/>
                    <i className="fa fa-trash ml-sm-2" style={{"fontSize": ".7rem"}}/>
                </Button>
            </InputGroup>
        </>

    );
};

export default injectIntl(ReportSearch);
